import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Ładowanie...',
    saving: 'Zapisywanie...',
    save: 'Zapisz',
    back: 'Wstecz',
    error: 'Błąd',
    notSet: 'Nie ustawiono',
    user: 'Użytkownik',
    system: 'System',
    copied: 'Skopiowano!',
    copy: 'Kopiuj',
    cancel: 'Anuluj',
    creating: 'Tworzenie...',
    processing: 'Przetwarzanie...',
    you: 'Ty',
    stars: 'Stars',
    seeAll: 'Zobacz wszystko',
    filter: 'Filtruj',
    amount: 'Kwota',
    date: 'Data',
    details: 'Szczegóły',
    mustBeLoggedIn: 'Musisz być zalogowany',
    daysShort: 'd',
    hoursShort: 'godz',
    minutesShort: 'min',
    justNow: 'Przed chwilą',
    noTitle: 'Bez tytułu',
    payment: 'płatność',
    payments: 'płatności',
  },
  layout: {
    dashboard: 'Panel',
    invoices: 'Faktury',
    ledger: 'Księga',
    withdraws: 'Wypłaty',
    redirects: 'Przekierowania',
    settings: 'Ustawienia',
    admin: 'Admin',
    profile: 'Profil',
    logout: 'Wyloguj',
    tonConfigured: 'TON skonfigurowany',
    configureTon: 'Skonfiguruj TON',
    tonNotConfigured: 'Adres TON nie skonfigurowany',
    active: 'Aktywny',
    walletConnect: 'Połącz portfel',
    walletTitle: 'Połącz swój portfel TON',
    walletSubtitle: 'Podaj adres TON, na który będą wysyłane Twoje wypłaty.',
    walletConnectedTitle: 'Portfel połączony',
    walletConnectedSubtitle: 'Twoje wypłaty będą wysyłane na ten adres.',
    walletCurrentAddress: 'Połączony adres',
    walletAddressLabel: 'Adres TON',
    walletHint: 'Akceptowany format user-friendly (EQ… / UQ…) lub raw (0:…).',
    walletInvalidAddress: 'Nieprawidłowy adres TON',
    walletUpdate: 'Zaktualizuj adres',
    walletChangeAddress: 'Zmień adres',
    walletDisconnect: 'Odłącz',
    walletDisconnectConfirmTitle: 'Odłączyć portfel?',
    walletDisconnectConfirmBody: 'Nie będziesz mógł zlecać wypłat, dopóki nie połączysz nowego adresu.',
    walletSaved: 'Portfel połączony pomyślnie',
    walletDisconnected: 'Portfel odłączony',
    newPaymentLink: 'Nowy link płatności',
    openBot: 'Bot Telegram',
    helpCenter: 'Centrum pomocy',
  },
  login: {
    seoTitle: 'Logowanie | Platforma płatności Telegram Stars',
    seoDescription: 'Zaloguj się na swoje konto Telegram Stars Payment Platform',
    signIn: 'Logowanie',
    signUp: 'Rejestracja',
    email: 'E-mail',
    password: 'Hasło',
    displayNameOptional: 'Nazwa wyświetlana (opcjonalnie)',
    displayNamePlaceholder: 'Twoje imię',
    emailPlaceholder: 'twoj@email.com',
    signInButton: 'Zaloguj się',
    signUpButton: 'Zarejestruj się',
    signInWithGoogle: 'Zaloguj się przez Google',
    or: 'LUB',
    welcome: 'Witamy',
    subtitle: 'Zaloguj się lub utwórz konto, aby rozpocząć',
    minPasswordHint: 'Minimum 6 znaków',
    tipTelegram: '💡 Wskazówka: możesz połączyć konto Telegram w ustawieniach po rejestracji',
    continueWithTelegram: 'Kontynuuj z Telegram',
    telegramAuthError: 'Logowanie przez Telegram nie powiodło się. Spróbuj ponownie.',
    featureInstant: 'Natychmiastowe tworzenie konta',
    featureManage: 'Zarządzaj płatnościami Telegram Stars',
    featureWithdraw: 'Wypłać środki w TON',
    emailRequired: 'Wprowadź adres e-mail',
    emailInvalid: 'Nieprawidłowy format e-mail',
    passwordRequired: 'Wprowadź hasło',
    passwordRequiredSignup: 'Wprowadź hasło',
    passwordMinLength: 'Hasło musi zawierać co najmniej 6 znaków',
    genericError: 'Wystąpił błąd',
    recaptchaFailed: 'Weryfikacja reCAPTCHA nie powiodła się. Spróbuj ponownie.',
    invalidCredentials: 'Nieprawidłowy e-mail lub hasło. Jeśli nie masz jeszcze konta, utwórz je w zakładce „Rejestracja".',
    wrongPassword: 'Nieprawidłowe hasło. Sprawdź hasło.',
    tooManyAttempts: 'Zbyt wiele prób. Spróbuj ponownie później.',
    accountDisabled: 'To konto zostało wyłączone. Skontaktuj się z pomocą techniczną.',
    authNotEnabled: 'Uwierzytelnianie e-mail/hasło nie jest włączone. Sprawdź konfigurację Firebase.',
    emailInUse: 'Ten e-mail jest już używany. Zaloguj się tym adresem.',
    googleAuthError: 'Wystąpił błąd podczas uwierzytelniania Google',
    popupClosed: 'Okno popup zostało zamknięte. Spróbuj ponownie.',
    popupBlocked: 'Okno popup zostało zablokowane. Zezwól na popupy i spróbuj ponownie.',
    popupCancelled: 'Dozwolone jest tylko jedno żądanie popup na raz.',
  },
  dashboard: {
    loading: 'Ładowanie panelu...',
    overallSummary: 'Podsumowanie ogólne',
    lastMonth: 'Ostatni miesiąc',
    lastWeek: 'Ostatni tydzień',
    lastYear: 'Ostatni rok',
    balance: 'Saldo',
    available: 'Dostępne',
    totalEarned: 'Łącznie zarobiono',
    fromLastMonth: 'w porównaniu do ostatniego miesiąca',
    recentPayments: 'Ostatnie płatności',
    last7days: 'Ostatnie 7 dni',
    last30days: 'Ostatnie 30 dni',
    quickActions: 'Szybkie akcje',
    createLink: 'Utwórz link',
    createLinkDesc: 'Wygeneruj nowy link płatności',
    withdraw: 'Wypłać',
    withdrawDesc: 'Wypłać Stars w TON',
    invoices: 'Faktury',
    invoicesDesc: 'Zobacz historię płatności',
    ledger: 'Księga',
    ledgerDesc: 'Zobacz wszystkie transakcje',
    recentActivity: 'Ostatnia aktywność',
    noRecentActivity: 'Brak ostatniej aktywności',
    mostRecent: 'Najnowsze',
    noRecentInvoices: 'Brak ostatnich faktur',
    allInvoices: 'Wszystkie faktury',
    paymentReceived: 'Otrzymano płatność: {title}',
    withdrawalRequested: 'Wypłata zażądana: {amount} {suffix}',
    transaction: 'Transakcja: {amount} {suffix}',
    invoiceLabel: 'Faktura #{id}',
    failedLoadBalance: 'Nie udało się załadować salda',
    chartAmount: 'Kwota',
  },
  invoices: {
    loading: 'Ładowanie...',
    allInvoices: 'Wszystkie faktury',
    paid: 'Opłacone',
    sent: 'Wysłane',
    created: 'Utworzone',
    expired: 'Wygasłe',
    filter: 'Filtruj',
    createInvoice: '+ Utwórz fakturę',
    noInvoices: 'Nie znaleziono faktur',
    relatedTo: 'Powiązane z:',
    paymentMode: 'Płatność {mode}',
    copyLink: 'Kopiuj link',
    copyLinkTitle: 'Kopiuj link faktury',
    linkNotAvailable: 'Link faktury niedostępny',
    linkCopied: 'Link faktury skopiowany do schowka!',
    copyFailed: 'Nie udało się skopiować linku',
    failedLoad: 'Nie udało się załadować faktur',
    statusPaid: 'opłacona',
    statusSent: 'wysłana',
    statusCreated: 'utworzona',
    statusExpired: 'wygasła',
    typeSingleUse: 'jednorazowy',
    typeRecurring: 'cykliczny',
  },
  createInvoice: {
    back: 'Wstecz',
    title: 'Utwórz link płatności',
    subtitle: 'Wygeneruj nowy link płatności w kilka sekund',
    successTitle: 'Link płatności utworzony!',
    successSubtitle: 'Twój link płatności jest gotowy do udostępnienia',
    paymentLink: 'Link płatności:',
    integrationTitle: 'Zintegruj ten link na swojej stronie',
    integrationDesc: 'Nasz bot Telegram poprowadzi Cię krok po kroku (API, przycisk HTML, przekierowania).',
    openTutorial: 'Otwórz samouczek',
    testLink: 'Przetestuj link',
    viewInvoices: 'Zobacz moje faktury',
    createNew: 'Utwórz nowy link',
    shareTelegram: 'Udostępnij w Telegramie',
    paymentMode: 'Tryb płatności',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Kwota (liczba całkowita)',
    amountDecimal: 'Kwota (dziesiętna)',
    amountRequired: 'Wprowadź kwotę',
    amountIntegerError: 'Kwota musi być liczbą całkowitą większą niż 0',
    amountNoDecimals: 'Kwota w Stars musi być liczbą całkowitą (bez miejsc dziesiętnych)',
    amountMustBeInteger: 'Kwota w Stars musi być liczbą całkowitą',
    amountGreaterThanZero: 'Kwota musi być większa niż 0',
    titleOptional: 'Tytuł (opcjonalnie)',
    titlePlaceholder: 'Tytuł płatności (np.: Płatność za usługi)',
    descriptionOptional: 'Opis (opcjonalnie)',
    descriptionPlaceholder: 'Szczegółowy opis płatności...',
    singleUse: 'Link jednorazowy',
    singleUseTooltip: 'Jeśli włączone, link można użyć tylko raz. Po opłaceniu stanie się nieważny.',
    createLink: 'Utwórz link',
    cancel: 'Anuluj',
    invalidAmount: 'Nieprawidłowa kwota',
    starsMustBeInteger: 'Kwota musi być liczbą całkowitą dla Stars',
    createError: 'Błąd tworzenia faktury',
  },
  ledger: {
    title: 'Księga',
    typeColumn: 'Typ',
    description: 'Pełna historia wszystkich transakcji',
    loading: 'Ładowanie...',
    noEntries: 'Brak transakcji w tej chwili.',
    typePayment: 'Płatność',
    typeFee: 'Opłata',
    typeNetPayment: 'Płatność netto',
    typeWithdrawal: 'Wypłata',
    typeAdjustment: 'Korekta',
    amountStars: 'Kwota (Stars)',
    invoiceDetail: 'Faktura: {title} ({amount} Stars)',
    paidBy: 'Opłacone przez: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Wypłata: {amount} Stars (Status: {status})',
    failedLoad: 'Nie udało się załadować księgi',
  },
  withdraws: {
    title: 'Moje wnioski o wypłatę',
    newRequest: '+ Nowy wniosek',
    totalLedger: 'Suma księgi',
    available: 'Dostępne',
    pendingWithdrawals: 'Oczekujące wypłaty',
    hold21days: 'Blokada 21 dni',
    payoutNote: 'Wypłaty są przetwarzane ręcznie przez administratora. Przy wypłacie pobierana jest opłata 3%.',
    forecastTitle: 'Prognoza wypłat',
    loadingForecast: 'Ładowanie prognozy...',
    noForecast: 'Brak nadchodzących dat wypłat',
    paymentsCount: '({count} płatności)',
    noRequests: 'Brak wniosków o wypłatę w tej chwili.',
    createFirst: 'Utwórz pierwszy wniosek',
    amount: 'Kwota:',
    destination: 'Cel:',
    processedOn: 'Przetworzono:',
    externalRef: 'Referencja zewnętrzna:',
    errorLabel: 'Błąd:',
    rejectionReason: 'Powód odrzucenia:',
    failedLoad: 'Nie udało się załadować wypłat',
    loading: 'Ładowanie...',
  },
  createWithdraw: {
    title: 'Złóż wniosek o wypłatę',
    balanceSource: 'Saldo (źródło: księga backend)',
    available: 'Dostępne: {amount} Stars',
    pending: 'Oczekujące wypłaty: {amount} Stars',
    waiting: 'Blokada 21 dni: {amount} Stars',
    minAndFee: 'Minimalna wypłata: {min} Stars · Opłata platformy: 3% przy wypłacie (przetwarzanie ręczne)',
    amountLabel: 'Kwota (Stars)',
    minPlaceholder: 'Minimum: {min}',
    feeHint: 'Brutto: {gross} Stars · Opłata (3%): {fee} Stars · Otrzymujesz: {net} Stars',
    useRegistered: 'Użyj mojego zarejestrowanego adresu TON',
    registeredAddress: 'Zarejestrowany adres:',
    tonDestination: 'Adres docelowy TON',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Format: EQ... lub 0:... (base64 lub hex)',
    createRequest: 'Utwórz wniosek',
    cancel: 'Anuluj',
    creating: 'Tworzenie...',
    insufficientBalance: '⚠️ Niewystarczające saldo do wypłaty (minimum: {min} Stars)',
    amountMustBeInteger: 'Kwota musi być dodatnią liczbą całkowitą',
    createError: 'Błąd tworzenia wniosku o wypłatę',
  },
  redirects: {
    title: 'Linki przekierowujące',
    description: 'Twórz krótkie linki przekierowujące do wybranego URL. Udostępnienie linku /r/twoj-slug przekieruje odwiedzających na skonfigurowany URL.',
    newRedirect: 'Nowe przekierowanie',
    clicks: 'kliknięcia',
    unique: 'unikalne',
    links: 'linki',
    modalTitle: 'Nowe przekierowanie',
    slugLabel: 'Slug (identyfikator linku)',
    slugRequired: 'Pole wymagane',
    slugPattern: 'Tylko litery, cyfry, myślniki i podkreślenia',
    slugMax: 'Maks. 64 znaki',
    slugReserved: 'Ten slug jest zarezerwowany. Wybierz inny.',
    slugPlaceholder: 'np.: moja-strona',
    urlLabel: 'URL docelowy',
    urlInvalid: 'Nieprawidłowy URL',
    urlHttpOnly: 'Akceptowane są tylko URL http i https.',
    urlTooLong: 'URL zbyt długi (maks. 2048 znaków).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Utwórz przekierowanie',
    loading: 'Ładowanie…',
    empty: 'Brak przekierowań. Kliknij „Nowe przekierowanie", aby utworzyć.',
    copyLink: 'Kopiuj link',
    linkCopied: 'Link skopiowany',
    deleteTitle: 'Usunąć to przekierowanie?',
    yes: 'Tak',
    no: 'Nie',
    delete: 'Usuń',
    totalClicks: 'Łącznie kliknięć',
    uniqueClicks: 'Unikalne kliknięcia',
    avgClicks: 'Śr. kliknięć/odwiedzający',
    loadError: 'Błąd ładowania przekierowań',
    createSuccess: 'Link przekierowujący utworzony',
    createError: 'Błąd tworzenia przekierowania',
    deleteSuccess: 'Przekierowanie usunięte',
    deleteError: 'Błąd usuwania przekierowania',
  },
  adminWithdraws: {
    title: 'Administracja - Wnioski o wypłatę',
    filterByStatus: 'Filtruj według statusu:',
    all: 'Wszystkie',
    noRequests: 'Brak wniosków dla tego statusu.',
    agent: 'Agent:',
    amount: 'Kwota:',
    destination: 'Cel:',
    processedOn: 'Przetworzono:',
    externalRef: 'Ref. zewn.:',
    errorLabel: 'Błąd:',
    reason: 'Powód:',
    approve: '✓ Zatwierdź',
    reject: '✗ Odrzuć',
    markPaid: '✓ Oznacz jako opłacone',
    markFailed: '✗ Oznacz jako nieudane',
    approveConfirm: 'Zatwierdzić ten wniosek o wypłatę?',
    rejectPrompt: 'Powód odrzucenia:',
    markPaidPrompt: 'Zewnętrzna referencja wypłaty (wymagana — hash tx TON, ref. bankowa itp.):',
    markPaidRequired: 'externalRef jest wymagany, aby potwierdzić ręczną wypłatę.',
    markFailedPrompt: 'Komunikat błędu:',
    approveError: 'Błąd zatwierdzania wypłaty',
    rejectError: 'Błąd odrzucania wypłaty',
    updateError: 'Błąd aktualizacji',
    failedLoad: 'Nie udało się załadować wypłat',
    notAuthenticated: 'Nie uwierzytelniono',
    operationFailed: 'Operacja nie powiodła się',
    loading: 'Ładowanie...',
  },
  redirectResolve: {
    missingSlug: 'Brak slug',
    invalidLink: 'Nieprawidłowy link',
    notFound: 'Link nie znaleziony',
    notFoundTitle: 'Link nie znaleziony',
    redirecting: 'Przekierowywanie...',
    redirectTitle: 'Przekierowanie',
  },
  errorBoundary: {
    title: 'Wystąpił błąd',
    subtitle: 'Przepraszamy, coś poszło nie tak. Spróbuj ponownie.',
    goHome: 'Powrót do strony głównej',
    reload: 'Odśwież stronę',
    devDetails: 'Szczegóły błędu (tylko dev):',
  },
};

export const settingsApp = {
  eyebrow: 'USTAWIENIA',
  profile: 'Profil',
  email: 'E-mail',
  telegramId: 'ID Telegram',
  notLinked: 'Nie połączono',
  linking: 'Łączenie...',
  linkTelegram: 'Połącz moje konto Telegram',
  openFromTelegram: '⚠️ Otwórz tę stronę z Telegrama, aby połączyć konto',
  displayName: 'Nazwa wyświetlana',
  displayNameHint: 'Nazwa wyświetlana jest ustawiana przy tworzeniu konta',
  withdrawal: 'Wypłata',
  tonAddress: 'Adres docelowy TON',
  tonAddressPlaceholder: 'EQAbc123... lub 0:...',
  tonAddressHint: 'Ten adres będzie domyślnie używany do wypłat',
  tonUpdated: 'Adres TON zaktualizowany pomyślnie',
  about: 'O aplikacji',
  commission: 'Prowizja platformy:',
  commissionValue: '3% od każdej płatności',
  minWithdrawal: 'Minimalna wypłata:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Waluta Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp niedostępny. Otwórz tę stronę z Telegrama.',
  telegramUserDataNotAvailable: 'Dane użytkownika Telegram niedostępne.',
  telegramLinked: 'Konto Telegram połączone pomyślnie!',
  linkTelegramError: 'Błąd łączenia konta Telegram',
  updateError: 'Błąd aktualizacji',
  mustBeLoggedIn: 'Musisz być zalogowany',
};
